var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddLocation = function SvgAddLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "add-location_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add-location_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14h1.5v-2.25H15v-1.5h-2.25V8h-1.5v2.25H9v1.5h2.25V14Zm.75 6c-2.012-1.712-3.516-3.303-4.51-4.772C6.498 13.76 6 12.4 6 11.15c0-1.875.603-3.369 1.81-4.481C9.015 5.556 10.412 5 12 5c1.588 0 2.984.556 4.19 1.669C17.398 7.78 18 9.275 18 11.15c0 1.25-.497 2.61-1.49 4.078-.994 1.469-2.498 3.06-4.51 4.772Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add-location_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgAddLocation as ReactComponent };